<template>
  <KeywordsComponent />
</template>

<script>
import KeywordsComponent from "@/sections/voiceplus/components/KeywordsComponent.vue";
import config from "@/config";

export default {
  name: "Modules",
  components: {
    KeywordsComponent,
  },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>
